import React, { useEffect, useState } from "react";
import "../styles/eventsSinglePage.css";
import { FaCalendarAlt } from "react-icons/fa";
import { AiOutlineClockCircle } from "react-icons/ai";
import { FaRegClone } from "react-icons/fa";
import EventBookingCard from "../components/EventBookingCard";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllEvents } from "../features/events/eventsSlice";
 import EventOverlay from "../components/eventOverlay";
import { createBooking } from "../features/booking/bookingSlice";
import { toast } from "react-toastify";
import BookingOverlay from "../components/eventOverlay";
import EventSingleLoader from "../components/EventSingleLoader";
import Meta from "../components/Meta";
import eventImg from "../images/kahenya/p.JPG";


const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const sameDay = start.toDateString() === end.toDateString();
  const options = { year: "numeric", month: "short", day: "numeric" };

  return sameDay
    ? start.toLocaleDateString(undefined, options)
    : `${start.toLocaleDateString(undefined, options)} – ${end.toLocaleDateString(undefined, options)}`;
};


// Inside EventsSinglePage.js

const events = [
  {
    id: "1",
    dateRange: "Aug 01 – Aug 04",
    time: "9:00 am",
    title: "Rooted in Identity",
    description: `<p>A guided journey to help youth discover their purpose, values, and unique voice.</p>`,
    image: eventImg,
    startDate: "2025-08-01",
    endDate: "2025-08-04",
    price: 0,
    courseLength: "4 Days",
    classDuration: 90,
    venue: "Potter's Grounds",
    city: "Nairobi",
  },
  {
    id: "2",
    dateRange: "Aug 10 – Aug 12",
    time: "2:00 pm",
    title: "Money Matters",
    description: `<p>An interactive workshop on budgeting, saving, and smart spending habits for teens.</p>`,
    image: eventImg,
    startDate: "2025-08-10",
    endDate: "2025-08-12",
    price: 0,
    courseLength: "3 Days",
    classDuration: 75,
    venue: "Potter's Grounds",
    city: "Nairobi",
  },
  {
    id: "3",
    dateRange: "Aug 17 – Aug 20",
    time: "10:00 am",
    title: "Leading with Heart",
    description: `<p>Hands-on leadership training to build confidence, communication, and compassion.</p>`,
    image: eventImg,
    startDate: "2025-08-17",
    endDate: "2025-08-20",
    price: 0,
    courseLength: "4 Days",
    classDuration: 90,
    venue: "Potter's Grounds",
    city: "Nairobi",
  },
];


const EventsSinglePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
   const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  

  const [contactDetails, setContactDetails] = useState({
     name: "",
     email: "",
     phone: "",
     
     contactMethod: "",  
   });
   
  useEffect(() => {
    dispatch(getAllEvents());
  }, [dispatch]);


  const [bookingSuccess, setBookingSuccess] = useState(false);
 
 
   const { isSuccess, isError, message, isLoading } = useSelector((state) => state.booking);
 
 
   useEffect(() => {
     if (isSuccess) {
       toast.success("Booking Created successfully!");
  
       setBookingSuccess(true);
 
     }
   
     if (isError) {
       toast.error(message || "Something went wrong!");
     }
   }, [isSuccess, isError, message, dispatch]);   

  const event = events.find((e) => e._id === id);



  if (!event) return <EventSingleLoader />;

 

    const handleContactChange = (e) => {
      const { name, value } = e.target;
      setContactDetails((prev) => ({ ...prev, [name]: value }));
    };
    
 
  

    const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true);
     
      const bookingData = {
        contactDetails,
        event: {
          id: event._id,
          title: event.title,
          startDate: event.startDate,
          endDate: event.endDate,
          price: event.price,
          venue: event.venue,
          city: event.city,
         },
      };
    
      console.log("Submitting booking:", bookingData);
      dispatch(createBooking(bookingData));
      
    };

  return (
    <>
    <Meta title={event.title}/>
      <div>
      <div className="single-event-container">
        <div
          className="course-banner"
          style={{
            backgroundImage: `url(${event?.images?.[0]?.url || "/default.jpg"})`,
          }}
        >
          <div className="event-overlay">
            <h2 className="course-title">{event.title}</h2>
          </div>
        </div>

        <div className="event-wrapper">
          <div className="event-details">
            <div className="event-single-card">
              <FaCalendarAlt className="icon" />
              <div>
                <p className="label">Start Date</p>
                <p className="value">
                  {formatDateRange(event.startDate, event.startDate)}
                </p>
              </div>
            </div>

            <div className="event-single-card">
              <FaCalendarAlt className="icon" />
              <div>
                <p className="label">End Date</p>
                <p className="value">
                  {formatDateRange(event.endDate, event.endDate)}
                </p>
              </div>
            </div>

            <div className="event-single-card">
              <FaRegClone className="icon" />
              <div>
                <p className="label">Course Length</p>
                <p className="value">{event.courseLength}</p>
              </div>
            </div>

            <div className="event-single-card">
              <AiOutlineClockCircle className="icon" />
              <div>
                <p className="label">Class Duration</p>
                <p className="value">{event.classDuration} Minutes</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="event-single-details-wrapper">
        <div className="event-overview">
          <h3>Overview</h3>
          <div className="overview-hr"></div>
          <div
            className="event-description"
            dangerouslySetInnerHTML={{ __html: event.description }}
          />

          <div className="events-youtube-container">
           <div className="ratio ratio-16x9">
    <iframe src="https://www.youtube.com/embed/UJCup8WgfJA?si=MMfOyQRcGYuCsCsq" title="YouTube video" allowFullScreen></iframe>
  </div>            
          </div>
        </div>
        <EventBookingCard event={event} onBookClick={() => setShowOverlay(true)} />

      </div>

      <BookingOverlay
      isOpen={showOverlay}
      loading={loading}
      onClose={() => setShowOverlay(false)}
      contactDetails={contactDetails}
      handleChange={handleContactChange}
      handleSubmit={handleSubmit}
      bookingSuccess={bookingSuccess}
    />

    </div>  
    </>

  );
};

export default EventsSinglePage;
